import React from "react";
import { useDispatch } from "react-redux";
import { setModalLoading } from "../../../actions/loading";
import Canvas from "../../../components/Canvas";

const FinalCtaSection = () => {
  const dispatch = useDispatch();

  const handleBookInterview = () => {
    dispatch(setModalLoading(true));
  };

  return (
    <section className="final-cta">
      <Canvas />
      <div className="container final-cta-inner">
        <div>
          <p className="eyebrow">Ready for a better search?</p>
          <h2>Stop Applying. Start Getting Interviews.</h2>
          <p>
            Book time with Lovapex and turn your job search into a managed,
            measurable process.
          </p>
        </div>
        <button
          className="button button-primary button-lg"
          onClick={() => handleBookInterview()}
        >
          Book a Free Strategic Consultation
        </button>
      </div>
    </section>
  );
};

export default FinalCtaSection;
